import { useMutation } from '@apollo/client';
import { graphql, useStaticQuery } from 'gatsby';
import React, { FC, useContext } from 'react';

import { keysToCamel } from '@utils/butter';

import GraphQLv2Context from '@providers/GraphQLv2ContextProvider';

import { IPageProps } from '@folx-types/flow-steps';

import CANCEL_MEMBER_SUBSCRIPTION_MUTATION from '@graphql/mutations/Subscription/CancelMemberSubscription.mutation.gql';
import APPLY_WINBACK_OFFER from '@graphql/mutations/applyWinbackOffer.mutation.gql';

import CancelationWinback, { ICancelationWinbackPageContent } from './CancelationWinback.component';

interface ICancelationWinbackPageProps extends IPageProps {}

const CancelationWinbackPage: FC<ICancelationWinbackPageProps> = ({ path }) => {
	const { pageContent } = useStaticQuery(graphql`
		{
			pageContent: butterPage(slug: { eq: "cancelation-winback" }) {
				page_header
				page_info
				stay_label
				cancel_label
				support_winback
				support_cancel
			}
		}
	`);

	const refinedContent: ICancelationWinbackPageContent = keysToCamel(
		pageContent
	) as ICancelationWinbackPageContent;

	const { client: graphQLv2Client } = useContext(GraphQLv2Context);
	const [cancelMembership] = useMutation(CANCEL_MEMBER_SUBSCRIPTION_MUTATION, {
		client: graphQLv2Client,
	});

	const [applyWinbackOffer] = useMutation(APPLY_WINBACK_OFFER, {
		client: graphQLv2Client,
	});

	return (
		<CancelationWinback
			pageContent={refinedContent}
			cancelMembership={cancelMembership}
			applyWinbackOffer={applyWinbackOffer}
			path={path}
		/>
	);
};

export default CancelationWinbackPage;
